import _typeof from "E:/wnmp/www/www.yunkezan.com/vuecli3/node_modules/@babel/runtime/helpers/esm/typeof.js";
import { initCountDown as _initCountDown } from '@ykz/ykz-util/base';

/* eslint-disable */
/* 限时或限份奖励活动信息组件
 * <component-float-up></component-float-up>
 * promoter:奖励数据
 */
export default {
  name: 'float_up',
  data: function data() {
    return {
      isAPP: window.mobileEnv == 'app' ? true : false,
      //是否在云客赞app打开页面
      promoter: {},
      //推广员信息
      timeObj: {},
      //倒计时对象
      queueStatus: -1 //0:未开始，1：进行中，2：已结束
    };
  },

  mounted: function mounted() {
    _typeof(window.componentCenter) == 'object' || (window.componentCenter = {});
    window.componentCenter.floatUp = this;
    console.log('ycf组件初始化：floatUp');
  },
  methods: {
    //初始化倒计时
    initCountDown: function initCountDown(promoter) {
      this.promoter = promoter || {};
      var that = this,
        rsecond = 0;
      if (this.promoter.currentTime < this.promoter.startTimeCountDown) {
        this.queueStatus = 0;
        rsecond = this.promoter.startTimeCountDown - this.promoter.currentTime;
      } else if (this.promoter.activityType == 1) {
        //限份
        this.queueStatus = this.promoter.num > 0 ? 1 : 2;
        rsecond = 0;
        return;
      } else if (this.promoter.currentTime >= this.promoter.startTimeCountDown && this.promoter.currentTime < this.promoter.endTimeCountDown) {
        this.queueStatus = 1;
        rsecond = this.promoter.endTimeCountDown - this.promoter.currentTime;
      } else {
        this.queueStatus = 2;
        rsecond = 0;
        return;
      }
      _initCountDown({
        rsecond: rsecond,
        fn_cdIng: function fn_cdIng(timeObj) {
          //倒计时进行中
          that.timeObj = timeObj;
        },
        fn_cdEnd: function fn_cdEnd(timeObj) {
          //倒计时已结束
          that.timeObj = timeObj;
          that.$parent.getPromoter && that.$parent.getPromoter('update');
          that.$parent.showIncomeStatement && that.$parent.showIncomeStatement('update');
          componentCenter.selectStandard && componentCenter.selectStandard.updatePromoterData(that.$parent.promoter);
        }
      });
    }
  }
};